export default {
	totalPages: state => state.totalPages,
	postbacks: state => state.postbacks,
	shipments: state => state.shipments
};
